export default "__VITE_ASSET__D65JYMLr__"